<template>
  <div v-if="isVisible" class="env-ribbon-wrapper" @click="hide">
    <div class="env-ribbon">
      <span class="env-ribbon-text">{{ envName }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DevEnvRibbon',
  props: {
    environment: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isHidden: false
    };
  },
  watch: {
    '$route'() {
      this.isHidden = false;
    }
  },
  computed: {
    isVisible() {
      return !this.isHidden && this.environment !== 'production';
    },
    envName() {
      return `検証環境(${this.environment})`;
    }
  },
  methods: {
    hide() {
      this.isHidden = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.env-ribbon-wrapper {
  width: 150px;
  height: 150px;
  position: fixed;
  overflow: hidden;
  top: 0;
  left: 0;
  z-index: 9999;
  pointer-events: none;
}

.env-ribbon {
  position: absolute;
  top: 42px;
  left: -43px;
  padding: 2px 0;
  background-color: #a00;
  background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.15));
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.5);
  font: 700 13px 'Helvetica Neue', Helvetica, Arial, sans-serif;
  transform: rotate(-45deg);
  z-index: 9999;
  pointer-events: auto;
  opacity: 1;
  transition: opacity 0.25s ease-in-out;
  cursor: pointer;
  
  &:hover {
    opacity: 0.2;
  }
}

.env-ribbon-text {
  color: #fff;
  text-decoration: none;
  text-shadow: 0 -1px rgba(0, 0, 0, 0.5);
  text-align: center;
  cursor: pointer;
  width: 200px;
  line-height: 20px;
  display: inline-block;
  padding: 2px 0;
  border-width: 1px 0;
  border-style: dotted;
  border-color: rgba(255, 255, 255, 0.7);
}

/* レスポンシブ対応 */
@media screen and (max-width: 768px) {
  .env-ribbon-wrapper {
    width: 120px;
    height: 120px;
  }
  
  .env-ribbon {
    top: 32px;
    left: -40px;
    font-size: 11px;
  }
  
  .env-ribbon-text {
    width: 150px;
    line-height: 16px;
    font-size: 10px;
  }
}

@media screen and (max-width: 480px) {
  .env-ribbon-wrapper {
    width: 100px;
    height: 100px;
  }
  
  .env-ribbon {
    top: 28px;
    left: -35px;
    font-size: 9px;
  }
  
  .env-ribbon-text {
    width: 120px;
    line-height: 14px;
    font-size: 8px;
  }
}
</style>
